'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Subscribed = require('./components/Subscribed.js');
var useSubscribeNotificationPreferenceMutate = require('../../hooks/useSubscribeNotificationPreferenceMutate.js');
var types = require('../../types.js');
var MarketingSubscribed = require('./components/MarketingSubscribed.js');
var MarketingUnsubscribed = require('./components/MarketingUnsubscribed.js');
var useUnsubscribeNotificationPreferenceMutate = require('../../hooks/useUnsubscribeNotificationPreferenceMutate.js');
var index = require('../../index.js');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var CprefMarketingSubscribed = require('./components/CprefMarketingSubscribed.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const CprefMarketing = ({
  featureName,
  isLandscape,
  contact,
  cprefOptedIn,
  cprefSubscribed,
  getNotificationPreferencesAndLevelData: preferencesData,
  narvarProfileUrl,
  onCprefExit
}) => {
  const {
    getNotificationPreferencesAndLevel
  } = preferencesData ?? {};
  const {
    notificationPrefDetails
  } = getNotificationPreferencesAndLevel ?? {};
  const networkSubscribed = notificationPrefDetails ? notificationPrefDetails?.length > 0 : false;
  const marketingSubscribed = networkSubscribed && !contact;
  const [cprefState, setCprefState] = React.useState(() => {
    if (marketingSubscribed && cprefSubscribed) {
      return 'cpref-marketing-subscribed';
    }
    if (cprefSubscribed || contact) {
      return 'subscribed';
    }
    return 'marketing-subscribed';
  });
  const [showContactInput, setShowContactInput] = React.useState(false);
  const [validationError, setValidationError] = React.useState(false);
  const [marketingOptinSuccess, setMarketingOptinSuccess] = React.useState(false);
  const {
    state: {
      orderNumbers,
      trackingNumbers
    }
  } = nthHookContextPage.usePageContext();
  const orderId = orderNumbers?.[0];
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const baseLogInfo = React.useMemo(() => ({
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    feature: featureName,
    orderNumber: orderId,
    pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    pageOrderNumber: orderId
  }), [featureName, orderId]);
  const {
    onSubscribeMutate,
    loading: subscribing
  } = useSubscribeNotificationPreferenceMutate.useSubscribeNotificationPreferenceMutate({
    data: preferencesData,
    options: {
      onCompleted: () => {
        setCprefState('marketing-subscribed');
        setMarketingOptinSuccess(true);
      },
      onError(error) {
        if (error && error.message.includes(index.ERROR_TYPES.VALIDATION_ERROR)) {
          setValidationError(true);
          logEvent({
            ...baseLogInfo,
            eventNotificationSmsValidationError: `${error.message}; cpref; page trackingNumber: ${trackingNumbers?.toString() || ''}`,
            eventType: nthHookContextAnalytics.NarvarEventTypes.ERROR
          });
        }
      }
    }
  });
  const {
    onUnsubscribeMutate,
    loading: unsubscribing
  } = useUnsubscribeNotificationPreferenceMutate.useUnsubscribeNotificationPreferenceMutate({
    data: preferencesData,
    options: {
      onCompleted: () => {
        setCprefState('marketing-unsubscribed');
      }
    }
  });
  const handleMarketingOptinSubmit = contact => {
    const notificationPrefDetails = [{
      channel: 'sms',
      contact
    }];
    onSubscribeMutate(types.Channels.SMS, notificationPrefDetails, false, true);
  };
  const handleTelephoneInputChange = () => {
    setValidationError(false);
  };
  const handleMarketingOptout = () => {
    onUnsubscribeMutate(types.Channels.SMS);
  };
  const handleSignUpAgainClick = () => {
    if (!cprefSubscribed && !cprefOptedIn) {
      onCprefExit();
      return;
    }
    setCprefState('subscribed');
    setShowContactInput(true);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, cprefState === 'subscribed' && /*#__PURE__*/React__default["default"].createElement(Subscribed["default"], {
    contact: contact,
    featureName: featureName,
    isLandscape: isLandscape,
    validationError: validationError,
    cprefOptedIn: cprefOptedIn,
    cprefSubscribed: cprefSubscribed,
    marketingSubscribed: marketingSubscribed,
    networkSubscribed: networkSubscribed,
    showContactInput: showContactInput,
    subscribing: subscribing,
    unsubscribing: unsubscribing,
    narvarProfileUrl: narvarProfileUrl,
    onTelephoneInputChange: handleTelephoneInputChange,
    onMarketingOptinSubmit: handleMarketingOptinSubmit,
    onMarketingOptout: handleMarketingOptout
  }), cprefState === 'marketing-subscribed' && /*#__PURE__*/React__default["default"].createElement(MarketingSubscribed["default"], {
    featureName: featureName,
    isLandscape: isLandscape,
    marketingOptinSuccess: marketingOptinSuccess,
    unsubscribing: unsubscribing,
    onChangeNumberClick: handleSignUpAgainClick,
    onUnsubscribeClick: handleMarketingOptout
  }), cprefState === 'marketing-unsubscribed' && /*#__PURE__*/React__default["default"].createElement(MarketingUnsubscribed["default"], {
    featureName: featureName,
    isLandscape: isLandscape,
    onSignUpAgainClick: handleSignUpAgainClick
  }), cprefState === 'cpref-marketing-subscribed' && /*#__PURE__*/React__default["default"].createElement(CprefMarketingSubscribed["default"], {
    featureName: featureName,
    isLandscape: isLandscape,
    narvarProfileUrl: narvarProfileUrl,
    onSignUpAgainClick: handleSignUpAgainClick
  }));
};

exports.CprefMarketing = CprefMarketing;
